import {ISegmentDto} from './SegmentDtoInterface';
import {generateUniqueString} from '../../../../../utils/random';

export default class Segment implements ISegmentDto {
  id: string;
  end: number;
  start: number;

  constructor(start: number, end: number) {
    this.id = generateUniqueString();
    this.end = end;
    this.start = start;
  }

  get length(): number {
    return this.end - this.start;
  }

  moveTo(newStart: number): void {
    const length = this.length;

    this.start = Math.max(0, Math.min(newStart, 1 - length));
    this.end = Math.max(this.start, this.start + length);
  }

  resize(newStart: number, newEnd: number): void {
    this.start = newStart;
    this.end = newEnd;
  }

  split(splitPoint: number): ISegmentDto {
    if (splitPoint <= this.start || splitPoint >= this.end) {
      throw new Error('Split point must be within the segment');
    }

    const newSegment = new Segment(splitPoint, this.end);

    this.end = splitPoint;

    return newSegment;
  }

  merge(otherSegment: ISegmentDto): boolean {
    let isMergedSussessfuly = false;

    if (this.end === otherSegment.start) {
      this.end = otherSegment.end;
      isMergedSussessfuly = true;
    } else if (this.start === otherSegment.end) {
      this.start = otherSegment.start;
      isMergedSussessfuly = true;
    }

    return isMergedSussessfuly;
  }

  overlaps(otherSegment: ISegmentDto): boolean {
    return this.start < otherSegment.end && this.end > otherSegment.start;
  }

  containsPoint(point: number): boolean {
    return point >= this.start && point <= this.end;
  }

  clone(): ISegmentDto {
    let clone = new Segment(this.start, this.end);

    clone.id = this.id;

    return clone;
  }

  toString(): string {
    return `Segment ${this.id}: [${this.start.toFixed(2)}, ${this.end.toFixed(2)}]`;
  }
}
